module.exports = __webpack_public_path__ + "93b5ea19a923e02b57f94f4ec96bb42d.png";